import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, RouterModule } from '@angular/router';

import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { CodeInputModule } from 'angular-code-input';
import { NotifierModule } from 'angular-notifier';

// pages
import { SelectRoomPage } from './pages/select-room/select-room.page';
import { LandingPage } from './pages/landing/landing.page';
import { RegisterPage } from './pages/register/register.page';
import { GroupRegistrationPage } from './pages/group-registration/group-registration.page';
import { AppTextPrivacyPolicyComponent } from './pages/app-text-privacy-policy/app-text-privacy-policy.component';


// components
import { StartLayoutComponent } from './components/start-layout/start-layout.component';
import { AddChildModalComponent } from './components/modals/add-child-modal/add-child-modal.component';
import { ConsentComponent } from './consent/consent/consent.component';
import { ConsentGroupVisitComponent } from './consent-group-visit/consent-group-visit.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { IonicStorageModule } from '@ionic/storage-angular';
import { RegistrationComponent } from './registration.component';
import { RegistrationLoginPage } from './pages/login/login.page';
import { OnlineRegistrationComponent } from './pages/online-registration/online-registration/online-registration.component';
import { OnlineConsentComponent } from './pages/online-registration/online-consent/online-consent.component';
import { AppTextOnlinePrivacyPolicyComponent } from './pages/app-text-online-privacy-policy/app-text-online-privacy-policy.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    RegistrationComponent, SelectRoomPage, RegistrationLoginPage, LandingPage, RegisterPage, GroupRegistrationPage, StartLayoutComponent, AddChildModalComponent, ConsentComponent, ConsentGroupVisitComponent, OnlineRegistrationComponent, OnlineConsentComponent,
    AppTextPrivacyPolicyComponent, AppTextOnlinePrivacyPolicyComponent
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    RouterModule,
    HttpClientModule,
    FormsModule, ReactiveFormsModule,
    CodeInputModule,
    NotifierModule,
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
  ]
})
export class RegistrationModule { }
